import React from 'react'
import giftcard from "../../Images/gift-icon.png"
import { Link } from 'react-router-dom'

function SearchRewardCards() {
    return (
        <>
            <section className='howworkRewards_page'>
                <div className='cust_container'>
                    <div className="top_area">
                        <Link to="/reward" className="backbtn"> <i className="fa-solid fa-arrow-left-long" /></Link>
                        <h4 className="heading">Neoo search reward cards</h4>
                        <Link to="/my-wallet" className="icon">
                            <img
                                src={giftcard}
                                className="img-fluid"
                                alt="....."
                            />
                        </Link>
                    </div>

                    <div className='conetnt'>
                        <h4 className='head'>Neoo Search Reward Cards</h4>
                        <p className='mt-5'>The <strong>Neoo Search Reward Program</strong> is the ultimate tool for turning everyday interactions into moments of joy and customer satisfaction. Designed to drive repeat purchases and enhance loyalty, it empowers businesses and members to engage and grow together.</p>
                        <p>This program digitizes traditional reward systems, offering a smart, contactless, and environmentally friendly way to reward loyal users. With Neoo Search, there’s no need for paper cards — just a simple, modern, and sustainable digital experience that customers love. Based on how you earn and redeem points, your account will be automatically upgraded or downgraded to Silver, Gold, or Platinum card status.</p>

                        <p>Members can unlock exclusive benefits and milestones through reward tiers:</p>
                        <ul className='ml-5'>
                            <li><strong>Silver Card – 1500 Points</strong><br />Achieve your first milestone and enjoy basic reward benefits.</li>
                            <li><strong>Gold Card – 3000 Points</strong><br />Unlock enhanced perks, recognition, and higher reward value.</li>
                            <li><strong>Platinum Card – 5000 Points</strong><br />Reach the top tier and enjoy premium benefits, maximum visibility, and exclusive rewards.</li>
                        </ul>
                        <p className='mt-2'><strong>Engage smarter, go greener, and build loyalty that lasts — with Neoo Search Reward Cards.</strong></p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SearchRewardCards